<template>
  <div class="iv-pseronal iv-p-t-40 iv-p-b-40">
    <div class="iv-main-width iv-p-b-40">
      <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line iv-m-b-20"><span>个人信息</span></h1>
      <LayoutTitle title="基本信息">
        <FormLayout :readOnly="true" :model="baseInfo" :list="baseForm"></FormLayout>
      </LayoutTitle>
      <LayoutTitle title="党员信息" v-if="showPartyMember">
        <FormLayout :readOnly="true" :model="partyMemberInfo" :list="partyMember"></FormLayout>
      </LayoutTitle>
      <LayoutTitle title="党组织信息" v-if="showPartyInfo">
        <FormLayout :readOnly="true" :model="partyOrgInfo" :list="partyInfo"></FormLayout>
      </LayoutTitle>
      <LayoutTitle title="会员信息" v-if="showFullMember && showinfo">
        <FormLayout :readOnly="true" :model="fullMemberInfo" :list="fullMember"></FormLayout>
      </LayoutTitle>
      <LayoutTitle title="工会信息" v-if="showFullOrgInfo && showinfo">
        <FormLayout :readOnly="true" :model="fullOrgInfo" :list="fullInfo"></FormLayout>
      </LayoutTitle>
      <LayoutTitle title="团员信息" v-if="showLeagueMember">
        <FormLayout :readOnly="true" :model="leagueMemberInfo" :list="leagueMember"></FormLayout>
      </LayoutTitle>
      <LayoutTitle title="团组织信息" v-if="showLeagueOrgInfo">
        <FormLayout :readOnly="true" :model="leagueOrgInfo" :list="leagueInfo"></FormLayout>
      </LayoutTitle>
      <LayoutTitle title="宣传团队信息" v-if="showEnterpriseMember">
        <FormLayout :readOnly="true" :model="enterpriseInfo" :list="enterpriseMember"></FormLayout>
      </LayoutTitle>
      <!-- <LayoutTitle title="企划人员信息" v-if="planningMember.length">
        <FormLayout :readOnly="true" :model="planningInfo" :list="planningMember"></FormLayout>
      </LayoutTitle> -->
      <LayoutTitle title="奖励信息">
        <DragTable
          noSearch
          class="iv-m-t-24"
          :showSelect="false" 
          ref="DragTable"
          :immediateForce="true" 
          :columns="rewardColumn" 
          :showPage="true"
          :showEdit="false"
          :showDelete="false"
          url="api-uum/module/reward/listRewardUserOrOrg"
          :listData="rewardData">
        </DragTable>
      </LayoutTitle>
      <LayoutTitle title="惩处信息">
        <DragTable
          noSearch 
          class="iv-m-t-24"
          :showSelect="false" 
          ref="DragTable"
          :immediateForce="true" 
          :columns="punishColumn" 
          :showPage="true"
          :showEdit="false"
          :showDelete="false"
          url="api-uum/module/reward/listRewardUserOrOrg"
          :listData="punishData">
        </DragTable>
      </LayoutTitle>
    </div>
    <RewardDetail ref="RewardDetail"></RewardDetail>
    <FooterOperator>
      <div class="iv-text-center">
        <Button type="back" @click="back">返回</Button>
      </div>
    </FooterOperator>
  </div>
</template>

<script>
import baseForm from './base.js'
import {timeFormat} from '@/utils'
import fullMember from './full-member'
import fullInfo from './full-info'
import partyMember from './party-member.js'
import leagueMember from './league-member.js'
import leagueInfo from './league-info.js'
import partyInfo from './party-info.js'
import planningMember from './planning.js'
import RewardDetail from './reward-detail.vue'
import enterpriseMember from './enterprise-member.js'
import FormLayout from '@/components/layout/form'
import DragTable from '@/components/drag-table-inline'
import { rewardColumn, punishColumn } from './column.js'
import FooterOperator from '@/components/footer-operator'
import LayoutTitle from '@/components/layout/layout-title'

export default {
  data () {
    return {
      showinfo: true,
      baseInfo: {},
      dictMap: {},
      partyMemberInfo: {},
      fullMemberInfo: {},
      leagueMemberInfo: {},
      partyMember: [],
      leagueMember: [],
      leagueInfo: [],
      leagueOrgInfo: {},
      fullMember: [],
      fullInfo: [],
      fullOrgInfo: {},
      partyInfo: [],
      partyOrgInfo: {},
      enterpriseMember: [],
      enterpriseInfo: {},
      planningInfo: {},
      planningMember: [],
      showPartyMember: false,
      showPartyInfo: false,
      showFullMember: false,
      showFullOrgInfo: false,
      showLeagueMember: false,
      showLeagueOrgInfo: false,
      showEnterpriseMember: false,
      rewardData: {
        rewardType: -1,
        rewardObject: -2,
        userId: sessionStorage.getItem('userId')
      },
      punishData: {
        rewardType: -2,
        rewardObject: -2,
        userId: sessionStorage.getItem('userId')
      }
    }
  },
  async created () {
    this.showinfo = true
    this.userId = this.$decode(sessionStorage.getItem('userId'))
    this.baseForm = baseForm.call(this)
    this.rewardColumn = rewardColumn.call(this)
    this.punishColumn = punishColumn.call(this)
    await this.getCodeTable('BOE72', 'YWX03')
    this.getPersonalInfo()
    this.setShowIcon()
    this.getCodeTable('BOE702', 'YWX04')
    this.getCodeTable('KZ41')
  },
  provide () {
    return {
      expandParent: this.expandParent
    }
  },
  methods: {
    //行内按钮
    expandParent (type, item) {
      this.$refs.RewardDetail.open(item)
    },
    async setShowIcon () {
      // const identityType = JSON.parse(sessionStorage.getItem('identityType') || '')
      // if (identityType.includes('YWX04')) {
      this.leagueMember = leagueMember.call(this)
      this.leagueInfo = leagueInfo.call(this)
      this.fullInfo = fullInfo.call(this)
      this.getLeagueMemberInfo()
      // }
      // if (identityType.includes('YWX03')) {
      this.fullMember = fullMember.call(this)
      this.fullInfo = fullInfo.call(this)
      this.getFullMemberInfo()
      // }
      // if (identityType.includes('YWX01')) {
      this.getPartyMemberInfo()
      await this.getCodeTable('BJ507')
      this.partyMember = partyMember.call(this)
      this.partyInfo = partyInfo.call(this)
      // }
      // if (identityType.includes('YWX05')) {
      this.enterpriseMember = enterpriseMember.call(this)
      this.getEnterpriseMember()
      // }
      // if (identityType.includes('YWX06')) {
      this.planningMember = planningMember.call(this)
      this.getPlanningMember()
      // }
    },
    //企划人员
    getPlanningMember () {
      this.$ajax({
        url: 'api-general/module/portal/user/byUserIdPink',
        method: 'get',
        data: {
          bizLineCode: 'YWX06'
        }
      }).then(({data}) => {
        if (!data.data) {
          this.showPlanningInfo = false
          this.planningInfo = {}
          return
        }
        this.showPlanningInfo = true
        this.planningInfo = Array.isArray(data.data) ? data.data[0] : data.data
        this.planningInfo.joinPartyDate = timeFormat(this.planningInfo.joinPartyDate)
      })
    },
    getEnterpriseMember () {
      // 企宣人员
      this.$ajax({
        url: 'api-general/module/portal/user/byUserIdPink',
        method: 'get',
        data: {
          bizLineCode: 'YWX05'
        }
      }).then(({data}) => {
        if (!data.data) {
          this.showEnterpriseMember = false
          this.enterpriseInfo = {}
          return
        }
        this.showEnterpriseMember = true
        this.enterpriseInfo = Array.isArray(data.data) ? data.data[0] : data.data
        this.enterpriseInfo.joinPartyDate = timeFormat(this.enterpriseInfo.joinPartyDate)
      })
    },
    //集成个人信息
    getPersonalInfo () {
      this.$ajax({
        url: '/api-uum/uuminfo/getUserInfo',
        method: 'get',
      }).then((data) => {
        this.baseInfo = data.data.data
        this.baseInfo.work4BOE = timeFormat(this.baseInfo.work4BOE)
        this.baseInfo.time2Work = timeFormat(this.baseInfo.time2Work)
      })
    },
    //党员信息
    getPartyMemberInfo () {
      this.$ajax({
        url: 'api-general/module/portal/user/byUserIdPink',
        method: 'get',
        data: {
          bizLineCode: 'YWX01'
        }
      }).then(({data}) => {
        if (!data.data) {
          this.showPartyMember = false
          this.partyMemberInfo = {}
          return
        }
        this.showPartyMember = true
        this.partyMemberInfo = Array.isArray(data.data) ? data.data[0] : data.data
        this.partyMemberInfo.fullPartyDate = timeFormat(Number(this.partyMemberInfo.fullPartyDate))
        this.partyMemberInfo.joinPartyDate = timeFormat(Number(this.partyMemberInfo.joinPartyDate))
        this.partyMemberInfo.partyArchiveState += ''
        let str = ''
        if (this.partyMemberInfo.partyDuty) {
          for (var key in this.partyMemberInfo.partyDuty) {  
            str += ',' + this.partyMemberInfo.partyDuty[key]
          }
          this.partyMemberInfo.partyDuty = str.slice(1)
        } else {
          this.partyMemberInfo.partyDuty = ''
        }
        let start = new Date()
        if (this.partyMemberInfo.fullPartyDate != '') {
          //转正日期
          let date1 = new Date(this.partyMemberInfo.fullPartyDate)
          let year = start.getFullYear() - date1.getFullYear()
          let month = start.getMonth() - date1.getMonth()
          if (month < 0) {
            year--
          }
          if (year < 1) {
            this.partyMemberInfo.partyStanding = '未满一年'
          } else {
            this.partyMemberInfo.partyStanding = year + '年'
          }
        }
      })
      this.getOrgInfo()
    },
    getOrgInfo () {
      this.$ajax({
        url: 'api-general/module/portal/user/getInfo',
        method: 'get',
        data: {
          bizLineCode: 'YWX01'
        }
      }).then(({data}) => {
        this.showPartyInfo = data.data.orgName ? true : false
        this.partyOrgInfo = data.data
        this.partyOrgInfo.nextChangeTime = this.partyOrgInfo.nextChangeTime ? new Date(this.partyOrgInfo.nextChangeTime) : ''
        this.partyOrgInfo.lastChangeTime = this.partyOrgInfo.lastChangeTime ? new Date(this.partyOrgInfo.lastChangeTime) : ''
      })
    },
    //团员信息
    getLeagueMemberInfo () {
      this.$ajax({
        url: 'api-general/module/portal/user/byUserIdPink',
        method: 'get',
        data: {
          bizLineCode: 'YWX04'
        }
      }).then(({data}) => {
        if (!data.data) {
          this.showLeagueMember = false
          this.leagueMemberInfo = {}
          return
        }
        this.showLeagueMember = true
        this.leagueMemberInfo = Array.isArray(data.data) ? data.data[0] : data.data
        this.leagueMemberInfo.userType = this.leagueMemberInfo.userType + ''
        this.leagueMemberInfo.isWorkOnSth = this.leagueMemberInfo?.isWorkOnSth + '' || ''
        this.leagueMemberInfo.expandFieldo = timeFormat(this.leagueMemberInfo.expandFieldo)
        this.leagueMemberInfo.jobTime = timeFormat(this.leagueMemberInfo.jobTime)
        let str = ''
        this.leagueMemberInfo.userType = this.leagueMemberInfo.userType + ''
        if (this.leagueMemberInfo.partyDuty) {
          for (var key in this.leagueMemberInfo.partyDuty) {  
            str += ',' + this.leagueMemberInfo.partyDuty[key]
          }
          this.leagueMemberInfo.partyDuty = str.slice(1)
        } else {
          this.leagueMemberInfo.partyDuty = ''
        }
        this.getLeagueOrgInfo()
      })
    },
    // 团组织
    getLeagueOrgInfo () {
      this.$ajax({
        url: 'api-general/module/portal/user/getInfo',
        method: 'get',
        data: {
          bizLineCode: 'YWX04'
        }
      }).then(({data}) => {
        this.showLeagueOrgInfo = data.data.orgName ? true : false
        this.leagueOrgInfo = data.data
        if (typeof this.leagueOrgInfo.orgFieldaa == 'string') {
          this.leagueOrgInfo.orgFieldaa = this.leagueOrgInfo.orgFieldaa ? this.leagueOrgInfo.orgFieldaa - 0 : null
        }
        if (typeof this.leagueOrgInfo.orgFieldab == 'string') {
          this.leagueOrgInfo.orgFieldab = this.leagueOrgInfo.orgFieldab ? this.leagueOrgInfo.orgFieldab - 0 : null
        }
      })
    },
    //会员信息
    getFullMemberInfo () {
      this.$ajax({
        url: 'api-general/module/portal/user/byUserIdPink',
        method: 'get',
        data: {
          bizLineCode: 'YWX03'
        }
      }).then(({data}) => {
        if (!data.data) {
          this.showFullMember = false
          this.fullMemberInfo = {}
          return
        }
        this.showFullMember = true
        this.fullMemberInfo = Array.isArray(data.data) ? data.data[0] : data.data
        this.fullMemberInfo.joinPartyDate = timeFormat(this.fullMemberInfo.joinPartyDate)
        this.fullMemberInfo.approvalBuildingDate = timeFormat(this.fullMemberInfo.approvalBuildingDate)
        let str = ''
        if (this.fullMemberInfo.partyDuty) {
          for (var key in this.fullMemberInfo.partyDuty) {  
            str += ',' + this.fullMemberInfo.partyDuty[key]
          }
          this.fullMemberInfo.partyDuty = str.slice(1)
        } else {
          this.fullMemberInfo.partyDuty = ''
        }
        //判断是否会员，不是会员隐藏 工会 会员信息 模块
        if (this.fullMemberInfo.memberOrNot != '1') {
          this.showinfo = false
        }
        this.getFullOrgInfo()
      })
    },
    getFullOrgInfo () {
      // 工会信息
      this.$ajax({
        url: 'api-general/module/portal/user/getInfo',
        method: 'get',
        data: {
          bizLineCode: 'YWX03'
        }
      }).then(({data}) => {
        this.showFullOrgInfo = data.data.orgName ? true : false
        this.fullOrgInfo = data.data
        this.fullOrgInfo.approvalBuildingDate = timeFormat(this.fullOrgInfo.approvalBuildingDate)
        if (typeof this.fullOrgInfo.orgFieldu == 'string') {
          this.fullOrgInfo.orgFieldu = this.fullOrgInfo.orgFieldu - 0
        }
        if (typeof this.fullOrgInfo.orgFieldv == 'string') {
          this.fullOrgInfo.orgFieldv = this.fullOrgInfo.orgFieldv - 0
        }
        if (typeof this.fullOrgInfo.orgFieldx == 'string') {
          this.fullOrgInfo.orgFieldx = this.fullOrgInfo.orgFieldx - 0
        }
        if (typeof this.fullOrgInfo.orgFieldz == 'string') {
          this.fullOrgInfo.orgFieldz = this.fullOrgInfo.orgFieldz - 0
        }
      })
    },
    //获取数据字典
    getCodeTable (code, bizLineCode = 'YWX01') {
      this.$set(this.dictMap, code, [])
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: bizLineCode
          }
        }).then(({data}) => {
          this.dictMap[code] = data.data.map(item => ({
            label: item.title,
            value: item.value
          }))
          resolve()
        })
      })
    },
    back () {
      this.$router.push({
        name: 'index'
      })
    }
  },
  components: {
    DragTable,
    FormLayout,
    RewardDetail,
    LayoutTitle,
    FooterOperator
  }
}
</script>

<style lang="scss" scoped>
.iv-pseronal {
  min-height: 100%;;
  background-color: #fff;
}
</style>
